import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as stakeholders from '../../stakeholders'

export const RESOURCE = {
  payload: {
    description:
      'An individual or group affected by, or influential in, an organizational change initiative.',
    dimension: stakeholders.RESOURCE.payload,
    level: 0,
    name: 'Stakeholder',
    partialId: PartialId.Standard.create('stakeholder'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
